<template>
  <LangRouterLink :to="to" class="navigation__link">
    <Icon :id="icon"/>
    <span>{{ label }}</span>
  </LangRouterLink>
</template>

<script>
import {Icon, LangRouterLink} from '@/components/global'

export default {
  name: 'NavigationLink',
  components: {Icon, LangRouterLink},
  props: {
    icon: {
      type: String,
      required: true
    },
    label: {
      type: String,
      required: true
    },
    to: {
      type: Object,
      required: true
    }
  }
}
</script>